import React from 'react';
import resume from '../data/resume';

const MONO = '"Courier New", "Monaco", "Menlo", "Consolas", monospace';

// Terminal view of the projects: text only (title, subtitle, description, links,
// stack). Screenshots live in the professional view. `projects` defaults to the
// résumé data; it is a prop so tests can pass fixtures.
const Projects = ({ projects = resume.projects }) => {
  const sectionStyle = {
    textAlign: 'left'
  };

  const promptStyle = {
    fontSize: '14px',
    color: '#00FF00',
    margin: '0 0 5px 0',
    fontFamily: MONO
  };

  const headingStyle = {
    fontSize: 'clamp(16px, 4.5vw, 18px)',
    fontWeight: 'bold',
    margin: '0 0 15px 0',
    letterSpacing: '2px',
    color: '#00FF00',
    fontFamily: MONO,
    paddingLeft: 'clamp(12px, 4vw, 30px)'
  };

  const projectStyle = {
    marginBottom: '20px',
    padding: '10px',
    border: '1px solid #00FF00',
    backgroundColor: '#001100',
    marginLeft: 'clamp(12px, 4vw, 30px)'
  };

  const projectTitleStyle = {
    fontSize: '16px',
    fontWeight: 'bold',
    margin: '0 0 8px 0',
    letterSpacing: '1px',
    color: '#00FF00',
    fontFamily: MONO
  };

  const subtitleStyle = {
    fontSize: '13px',
    margin: '0 0 8px 0',
    lineHeight: '1.5',
    color: '#00FF00',
    opacity: 0.8,
    fontFamily: MONO
  };

  const projectDescStyle = {
    fontSize: '14px',
    margin: '0 0 5px 0',
    lineHeight: '1.5',
    color: '#00FF00',
    fontFamily: MONO
  };

  const linksStyle = {
    fontSize: '13px',
    margin: '0 0 6px 0',
    color: '#00FF00',
    fontFamily: MONO
  };

  const linkStyle = {
    color: '#00FF00',
    textDecoration: 'underline',
    textDecorationStyle: 'dotted',
    textUnderlineOffset: '3px',
    marginRight: '10px'
  };

  const techStyle = {
    fontSize: '12px',
    margin: '0',
    opacity: 0.8,
    fontStyle: 'italic',
    color: '#00FF00',
    fontFamily: MONO
  };

  return (
    <section style={sectionStyle}>
      <div style={promptStyle}>$ find projects/ -name "*.js" -o -name "*.py"</div>
      <h2 style={headingStyle}>[ PROJECTS ]</h2>
      {projects.map((project, index) => (
        <div key={index} style={projectStyle}>
          <h3 style={projectTitleStyle}>┌─ {project.title}</h3>
          {project.subtitle && <p style={subtitleStyle}>│ {project.subtitle}</p>}
          <p style={projectDescStyle}>│ {project.description}</p>
          {project.links && project.links.length > 0 && (
            <p style={linksStyle}>
              │ links:{' '}
              {project.links.map((l) => (
                <a key={l.href} href={l.href} target="_blank" rel="noopener noreferrer" style={linkStyle}>
                  [{l.label}]
                </a>
              ))}
            </p>
          )}
          <p style={techStyle}>└─ Stack: {project.tech.join(', ')}</p>
        </div>
      ))}
    </section>
  );
};

export default Projects;
